import { Controller, useFormContext } from 'react-hook-form'

import { useTranslation } from '../localization'
import { Input, WebsiteIcon } from '../ui-kit'

import { StartContent } from './start-content'
import { validateOptionalURL } from './validators'

interface WebsiteUrlFormControlContext {
  websiteUrl: string | undefined
}

export const WebsiteUrlFormControl = <
  _FormContext extends WebsiteUrlFormControlContext,
>() => {
  const { t } = useTranslation()
  const formContext = useFormContext<WebsiteUrlFormControlContext>()

  return (
    <Controller
      control={formContext.control}
      rules={{
        validate: (url) =>
          validateOptionalURL({
            url,
          }) || t('premium.form.invalid-url-website'),
      }}
      name="websiteUrl"
      render={({ field, fieldState }) => (
        <Input
          {...field}
          size="m"
          placeholder="https://www.example.com"
          error={fieldState.error?.message}
          startContent={
            <StartContent icon={<WebsiteIcon height={15} width={15} />}>
              {t('common.website')}
            </StartContent>
          }
        />
      )}
    />
  )
}
